import { CALL_API } from '../middleware/api'
import actionTypes from './actionTypes.js'
import { replace, push } from 'react-router-redux'
import Cookie from 'js-cookie'
import { AUTH_COOKIE_PATH, ONBOARDING_STEPS_MAP } from '../constants.js'
import isLoggedIn, { removeOnBoardingStep, getNextOnBoardingStep, getNextFlowStep } from '../utils/index'
import Url from '../utils/Url'
import { makeFSATripplet } from './utils'


function makeActionTriplet(action) {
  return [action, `${action}_DONE`, `${action}_FAIL`]
}


function fetchBaseState() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_BASE_STATE),
      endpoint: 'base-state/',
      method: 'get'
    }
  }
}


export function loadBaseState() {
  return (dispatch, getState) => {
    return dispatch(fetchBaseState());
  };
}


function signupUser(data={}) {
  let csrftoken = Cookie.get('csrftoken');
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SIGNUP),
      endpoint: 'user/auth/register/',
      method: 'post',
      data,
      headers: { 'X-CSRFToken': `${csrftoken}`},
      schema: null
    }
  };
}


export function doSignupUser(data) {
  return (dispatch, getState) => {
    return dispatch(signupUser(data)).then(function() {
      const state = getState();
      if(!state.signup.error) {
        Cookie.set(AUTH_COOKIE_PATH, state.signup.key);
        return dispatch(fetchLoggedInUser(state.signup.key));
      }
    }).then(function() {
      const state = getState();
      if (!state.signup.error) {
        return dispatch(closeSignupFormRequest())
      }
    });
  };
}


function loginUser(data={}) {
  let csrftoken = Cookie.get('csrftoken');
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.LOGIN),
      endpoint: 'user/auth/login/',
      method: 'post',
      data,
      headers: { 'X-CSRFToken': `${csrftoken}`},
      schema: null
    }
  };
}



export function fetchLoggedInUser(token) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_USER),
      endpoint: 'user/me/',
      method: 'get',
      data: null,
      headers: { 'Authorization': `Token ${token}`},
      schema: null
    }
  };
}

export function loadLoggedinUser(key=null) {
  let token = key || Cookie.get(AUTH_COOKIE_PATH);
  return (dispatch, getState) => {
    return dispatch(fetchLoggedInUser(token));
  };
}

function startOnBoarding() {
  return {
    type: actionTypes.START_ONBOARDING
  };
}

function FBLogin(payload) {
  let csrftoken = Cookie.get('csrftoken');
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SIGNUP),
      endpoint: 'user/auth/facebook/',
      method: 'post',
      data: payload,
      headers: { 'X-CSRFToken': `${csrftoken}`},
      schema: null
    }
  }
}

export function doFBLogin(payload) {
  return (dispatch, getState) => {
    return dispatch(FBLogin(payload))
      .then(() => {
        const state = getState();
        if(!state.signup.error) {
          Cookie.set(AUTH_COOKIE_PATH, state.signup.key);
          return dispatch(fetchLoggedInUser(state.signup.key));
        }
      })
      .then(() => {
        const state = getState();
        if(!state.signup.error) {
          return dispatch(closeLoginFormRequest())
        }
      })
      .then(() => {
        const state = getState();
        if(!state.signup.error) {
          return dispatch(closeSignupFormRequest())
        }
      })
    }
}


export function doLoginUser(data) {
  console.info("in login action ~~~~~~~~~~~~~~~~~~~~~~>", data)
  return (dispatch, getState) => {
    return dispatch(loginUser(data)).then(function() {
      const state = getState();
      if(state.auth.loggedIn) {
        Cookie.set(AUTH_COOKIE_PATH, state.auth.key);
        return dispatch(fetchLoggedInUser(state.auth.key)).then(function() {
          const state = getState();
          if (state.auth.loggedIn) {
            dispatch(closeLoginFormRequest())
            if (data.next) {
              dispatch(push(data.next))
            }
          }
        })
      }
    })
  };
}

function logoutUser() {
  return {
    [CALL_API]: {
      types: makeFSATripplet(actionTypes.LOGOUT),
      endpoint: 'user/auth/logout/',
      method: 'post',
      schema: null
    }
  };
}

export function doLogoutUser() {
  return (dispatch, getState) => {
    Cookie.remove(AUTH_COOKIE_PATH);
    return dispatch(logoutUser())
      .then(function(){
        //return dispatch(push('/'));
      });
  };
}

export function resetPassword(email) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.RESET_PASSWORD),
      endpoint: 'user/auth/password/reset/',
      method: 'post',
      data: {email}
    }
  }
}

export function doRestorePassword(email) {
  return (dispatch, getState) => {
    dispatch({type: actionTypes.RESET_PASSWORD_REQUEST, email: email});
    return dispatch(resetPassword(email)).then(() => {
      return dispatch(push('/user/forgotpassword/sent'));
    })
  };
}

export function setPassword({password, uid, token}) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SET_PASSWORD),
      endpoint: 'user/auth/password/reset/confirm/',
      method: 'post',
      data: {new_password1: password, new_password2: password, uid, token}
    }
  }
}

export function doSetPassword(params) {
  return (dispatch, getState) => {
    return dispatch(setPassword(params)).then((action) => {
      if (action.type === actionTypes.SET_PASSWORD_DONE || action.type === actionTypes.SET_PASSWORD_SUCCESS) {
        return dispatch(push('/user/resetpassword/success'));
      } else {
        return dispatch(push('/user/resetpassword/failed'));
      }
    })
  };
}

function UpdateOnBoardingSteps(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.UPDATE_ONBOARDING_STEPS),
      endpoint: 'boarding/',
      method: 'put',
      data,
      headers: { 'Authorization': `Token ${token}`},
      schema: null
    }
  };
}

export function doUpdateOnBoardingSteps(data) {
  return (dispatch, getState) => {
    return dispatch(UpdateOnBoardingSteps(data));
  };
}


function saveUserInfoStep(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_USER_INFO_STEP),
      endpoint: 'user/me/',
      method: 'patch',
      data,
      headers: { 'Authorization': `Token ${token}`},
      schema: null
    }
  };
}

export function doSaveUserInfoAgeLoc(data) {
  return (dispatch, getState) => {
    return dispatch(saveUserInfoStep(data));
  };
}


export function doSaveUserInfoStep(data) {
  return (dispatch, getState) => {
    return dispatch(saveUserInfoStep(data)).then(function() {
      const state = getState();
      // let onboarding = removeOnBoardingStep(state.auth.user.on_boarding, 'user_info');
      let depot = Object.assign({}, state.auth.user.depot)
      depot.flow = removeOnBoardingStep(depot.flow, '/user/info')
      return dispatch(saveMe({depot})).then(function(){
        const state = getState();
        return dispatch(replace(getNextOnBoardingStep(state.auth.user)));
      });
    });
  };
}


function sendVerificationEmail(data = null) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SEND_VERIFICATION_EMAIL),
      endpoint: 'user/me/sendverificationemail/',
      method: 'post',
      data,
      headers: { 'Authorization': `Token ${token}`},
      schema: null
    }
  };
}

export function doSendVerificationEmail(data=null) {
  return (dispatch, getState) => {
    return dispatch(sendVerificationEmail(data));
  };
}


function verifyEmail(data) {
  let authtoken = Cookie.get(AUTH_COOKIE_PATH);
  let csrftoken = Cookie.get('csrftoken');
  let headers = {}
  if (authtoken) {
    headers.Authorization = `Token ${authtoken}`
  }
  if (csrftoken) {
    headers['X-CSRFToken'] = csrftoken
  }
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.EMAIL_VERIFICATION),
      endpoint: 'user/verifyemail/',
      method: 'post',
      data,
      headers,
      schema: null
    }
  };
}


export function doVerifyEmail(data) {
  return (dispatch, getState) => {
    return dispatch(verifyEmail(data))
    .then(function(action) {
      if (action.type !== "EMAIL_VERIFICATION_FAIL") {
        const state = getState();
        let token = Cookie.get(AUTH_COOKIE_PATH);
        return dispatch(fetchLoggedInUser(token));
      }
      return false;
    })
  };
}

function fetchHomePageCategories() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_HOME_PAGE_CATEGORIES),
      endpoint: 'organizations/home-page-categories/',
      method: 'get',
    }
  };
}

export function loadHomePageCategories() {
  return (dispatch, getState) => {
    return dispatch(fetchHomePageCategories());
  };
}

function fetchHomeBannerFeaturedOrganizations() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_HOME_BANNER_FEATURED_ORGANIZATIONS),
      endpoint: 'organizations/is_org_banner_feature/'
    }
  }
}

export function loadBannerFeaturedOrgs() {
  return (dispatch, getState) => {
    return dispatch(fetchHomeBannerFeaturedOrganizations());
  }
}

// These are the organizations that are included in the featured regions. Fetch featured regions may have been a better choice of variable.
function fetchFeaturedHomeOrganizations() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FEATURED_HOME_ORGANIZATIONS),
      endpoint: 'organizations/is_org_featured/'
    }
  };
}

export function loadFeaturedHomeOrganizations() {
  return (dispatch, getState) => {
      return dispatch(fetchFeaturedHomeOrganizations());
  };
}

function fetchFeaturedOrgsSlider(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FEATURED_ORGS_SLIDER),
      endpoint: 'organizations/is_org_slider/',
      method: 'get',
      data,
      schema: null
    }
  };
}


export function loadFeaturedOrganizationFromDB(id) {
  return (dispatch, getState) => {
      return dispatch(fetchFeaturedOrganizationFromDB(id));
  };
}

function fetchFeaturedOrganizationFromDB(id) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FEATURED_ORGS_FROM_DB),
      endpoint: `organizations/featured/${id}/`,
      method: 'get',
      data: null,
      schema: null
    }
  };
}



export function loadFeaturedOrgsSlider(data) {
  return (dispatch, getState) => {
    return dispatch(fetchFeaturedOrgsSlider(data));
  };
}

function fetchHomeStories() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_HOMESTORIES),
      endpoint: 'user/home/stories/'
    }
  };
}

export function loadHomeStories() {
  return (dispatch, getState) => {
    return dispatch(fetchHomeStories());
  };
}


function fetchFestivalEventCategories() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FESTIVAL_EVENT_CATEGORIES),
      endpoint: 'girls-festival/event-categories/'
    }
  }
}

export function loadFestivalEventCategories() {
  return (dispatch, getState) => {
    return dispatch(fetchFestivalEventCategories());
  };
}


function fetchFestivalSponsorshipCategories(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_SPONSORSHIP_CATEGORIES),
      endpoint: 'girls-festival/sponsor-categories/',
      method: 'get',
      data,
      schema:null
    }
  };
}

export function loadFestivalSponsorshipCategories(data) {
  return (dispatch, getState) => {
    return dispatch(fetchFestivalSponsorshipCategories(data));
  };
}


function fetchFestivalSponsorsByCategory(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FESTIVAL_SPONSOR_BY_CATEGORY),
      endpoint: 'girls-festival/sponsors-by-category/',
      method: 'get',
      data,
      schema: null
    }
  };
}

export function loadFestivalSponsorsByCategory(data) {
  return (dispatch, getState) => {
    return dispatch(fetchFestivalSponsorsByCategory(data));
  };
}



function fetchFestivalEvents(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FESTIVAL_EVENTS),
      endpoint: 'girls-festival/events/',
      method: 'get',
      data,
      schema: null
    }
  };
}

export function loadFestivalEvents(data) {
  return (dispatch, getState) => {
    return dispatch(fetchFestivalEvents(data));
  };
}

function fetchFestivalProgramEventsByCategory(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FESTIVAL_PROGRAM_EVENTS_BY_CATEGORY),
      endpoint: 'girls-festival/events-by-category/',
      method: 'get',
      data,
      schema: null
    }
  }
}

export function loadFestivalProgramEventsByCategory(data) {
  return (dispatch, getState) => {
      return dispatch(fetchFestivalProgramEventsByCategory(data));
  };
}


function fetchSharedStories() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_SHARED_STORIES),
      endpoint: 'user/shared-stories/'
    }
  }
}


function fetchFestivalProgramLp() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FESTIVAL_PROGRAM_LP),
      endpoint: 'girls-festival/program-lp/'
    }
  }
}


export function loadFestivalProgramLP() {
  return (dispatch, getState) => {
    return dispatch(fetchFestivalProgramLp());
  };
}


export function loadSharedStories() {
  return (dispatch, getState) => {
    return dispatch(fetchSharedStories());
  };
}

function fetchStory(id) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_STORY),
      endpoint: `user/story/${id}/`,
      method: 'get',
      data: null,
      schema: null
    }
  };
}

export function loadStory(id) {
  return (dispatch, getState) => {
    return dispatch(fetchStory(id));
  };
}

function fetchBFWOffers() {
  return {
    [CALL_API]: {
      types:makeActionTriplet(actionTypes.FETCH_BFW_OFFERS),
      endpoint: 'organizations/bfw/offers/'
    }
  }
}

export function loadBFWOffers() {
  return (dispatch, getState) => {
    return dispatch(fetchBFWOffers());
  };
}

function fetchSharedStory(id) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_SHARED_STORY),
      endpoint: `user/shared-story/${id}/`,
      method: 'get',
      data: null,
      schema: null
    }
  }
}

export function loadSharedStory(id) {
  return (dispatch, getState) => {
    return dispatch(fetchSharedStory(id));
  };
}

function fetchBFWOffersFeatured() {
  return {
    [CALL_API]: {
      types:makeActionTriplet(actionTypes.FETCH_BFW_OFFERS_FEATURED),
      endpoint: 'organizations/bfw/offers/featured/'
    }
  }
}

export function loadBFWOffersFeatured() {
  return (dispatch, getState) => {
    return dispatch(fetchBFWOffersFeatured());
  };
}

function fetchFestivalNews() {
  return {
    [CALL_API]: {
      types:makeActionTriplet(actionTypes.FETCH_FESTIVAL_NEWS),
      endpoint: 'girls-festival/news/'
    }
  }
}

export function loadFestivalNews() {
  return (dispatch, getState) => {
    return dispatch(fetchFestivalNews());
  };
}


function fetchOrganizations(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_ORGANIZATIONS),
      endpoint: 'organizations/',
      method: 'get',
      data,
      schema: null
    }
  };
}

export function loadOrganizations(data) {
  if(data.global != null && data.global == false) {
    delete data.global;
  }

  return (dispatch, getState) => {
    return dispatch(fetchOrganizations(data));
  };
}


function fetchOrganizationClaim(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_ORGANIZATION_CLAIM),
      endpoint: 'organizations/claim/',
      method: 'get',
      data,
      schema: null
    }
  };
}


export function loadOrganizationClaim(id) {
  return (dispatch, getState) => {
    return dispatch(fetchOrganizationClaim({'id': id }));
  };
}

function fetchOrganization(id) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_ORGANIZATION),
      endpoint: `organizations/${id}`,
      method: 'get',
      data: null,
      schema: null
    }
  };
}

export function loadOrganization(id) {
  return (dispatch, getState) => {
    return dispatch(fetchOrganization(id)).then(function() {
      return dispatch(fetchOrganizationClaim({ id }));
    });
  };
}


function saveOrganization(id, data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_ORGANIZATION),
      endpoint: `organizations/${id}/update/`,
      method: 'patch',
      headers: { 'Authorization': `Token ${token}`},
      data,
      schema: null
    }
  };
}

export function doSaveOrganization(id, data, isEditMode = false) {
  return (dispatch, getState) => {
    return dispatch(saveOrganization(id, data)).then(function() {
      let { organization } = getState();
      return dispatch(replace((isEditMode ? `/organizations/edit/${organization.db_id}` : `/organizations/${organization.db_id}`)));
    });
  };
}


function claimOrganization(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_ORGANIZATION_CLAIM),
      endpoint: 'organizations/claim/',
      method: 'post',
      headers: { 'Authorization': `Token ${token}`},
      data
    }
  };
}

export function doClaimOrganization(data) {
  return (dispatch, getState) => {
    return dispatch(claimOrganization(data))
      .then(function() {
        const token = Cookie.get(AUTH_COOKIE_PATH);
        return dispatch(fetchLoggedInUser(token));
      })
      .then(function() {
        const state = getState();
        const { organization, temporal } = state;
        if(temporal.organizationClaim) {
            return dispatch(replace(`/organizations/edit/${organization.db_id}`));
        }
      });
  };
}


function fetchRegions() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_REGIONS),
      endpoint: `organizations/regions/`,
      method: 'get',
      data: null,
      schema: null
    }
  };
}

export function loadRegions() {
  return (dispatch, getState) => {
    return dispatch(fetchRegions());
  };
}


function saveMe(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_ME),
      endpoint: `user/me/`,
      method: 'patch',
      headers: { 'Authorization': `Token ${token}`},
      data
    }
  };
}

export function doSaveMe(data) {
  return (dispatch, getState) => {
    return dispatch(saveMe(data));
  };
}


function fetchMyInterests() {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_MY_INTERESTS),
      endpoint: 'user/me/interests/',
      method: 'get',
      headers: { 'Authorization': `Token ${token}`}
    }
  };
}

export function loadMyInterests() {
  return (dispatch, getState) => {
    return dispatch(fetchMyInterests());
  };
}


function fetchMyFavorites() {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_MY_FAVORITES),
      endpoint: 'user/me/favorites/',
      method: 'get',
      headers: { 'Authorization': `Token ${token}`}
    }
  };
}

export function loadMyFavorites() {
  return (dispatch, getState) => {
    return dispatch(fetchMyFavorites());
  };
}


function addFavorite(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.ADD_FAVORITE),
      endpoint: 'user/me/favorites/',
      method: 'post',
      data,
      headers: { 'Authorization': `Token ${token}`}
    }
  };
}


export function doAddFavorite(data) {
  return (dispatch, getState) => {
    return dispatch(addFavorite(data)).then(() => {
      let token = Cookie.get(AUTH_COOKIE_PATH);
      return dispatch(fetchLoggedInUser(token));
    });
  };
}


function deleteFavorite(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.DELETE_FAVORITE),
      endpoint: `user/me/favorites/${data.id}/`,
      method: 'delete',
      data: null,
      headers: { 'Authorization': `Token ${token}`}
    }
  };
}


export function doDeleteFavorite(data) {
  return (dispatch, getState) => {
    return dispatch(deleteFavorite(data)).then(() => {
      let token = Cookie.get(AUTH_COOKIE_PATH);
      return dispatch(fetchLoggedInUser(token));
    });
  };
}


export function updateMyInterests(categoryIds) {
  return {
    type: "UPDATE_MY_INTERESTS",
    categoryIds
  };
}

function fetchFavoriteOrganizations(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FAVORITE_ORGANIZATIONS),
      endpoint: 'organizations/',
      method: 'get',
      data,
      schema: null
    }
  };
}

export function loadFavoriteOrganizations(data) {
  return (dispatch, getState) => {
    return dispatch(fetchFavoriteOrganizations(data));
  };
}

function realSaveMyInterest(categoryIds) {
  let token = Cookie.get(AUTH_COOKIE_PATH)
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_MY_INTERESTS),
      endpoint: 'user/me/interests/',
      method: 'post',
      data: { category: categoryIds },
      headers: { 'Authorization': `Token ${token}`}
    }
  }
}
export function saveMyInterests(categoryIds) {
  return (dispatch, getState) => {
    return dispatch(realSaveMyInterest(categoryIds))
    .then(()=>{
      return dispatch(loadLoggedinUser())
    })
  }
}

function saveSharedStory(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_SHARED_STORY),
      endpoint: `user/me/shared-story/`,
      method: 'post',
      headers: { 'Authorization': `Token ${token}`},
      data
    }
  }
}

export function doSaveSharedStory(data) {
  return (dispatch, getState) => {
    return dispatch(saveSharedStory(data));
  };
}

function updateSharedStory(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.UPDATE_SHARED_STORY),
      endpoint: `user/me/shared-story/update/`,
      method: 'patch',
      headers: { 'Authorization': `Token ${token}` },
      data
    }
  }
}

export function doUpdateSharedStory(data) {
  return (dispatch, getState) => {
    return dispatch(updateSharedStory(data));
  };
}

function uploadSharedStoryPhoto(file, pk) {

  let csrftoken = Cookie.get('csrftoken');
  let token = Cookie.get(AUTH_COOKIE_PATH);
  let data = new FormData();
  data.append("www_photo", file);
  data.append("pk", pk);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.UPLOAD_SHARED_STORY_PHOTO),
      endpoint: `user/me/shared-story/update/`,
      method: 'patch',
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'multipart/form-data',
        'Authorization': `Token ${token}`

      },
      data,
      schema: null
    }
  };
}

export function doUploadSharedStoryPhoto(file, pk) {
  return (dispatch, getState) => {
    return dispatch(uploadSharedStoryPhoto(file, pk));
  };
}

function saveLeaderStory(data) {
  
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_LEADER_STORY),
      endpoint: `organizations/leader/story/`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data
    }
  }
}

export function doSaveLeaderStory(data) {
  return (dispatch) => {
    return dispatch(saveLeaderStory(data));
  }
}

function uploadLeaderStoryPhoto(file, pk) {
  let data = new FormData();
  data.append("photo", file);
  data.append("pk", pk);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.UPLOAD_LEADER_STORY_PHOTO),
      endpoint: `leader/story/`,
      method: 'patch',
      data,
      schema: null
    }
  }
}

export function doUploadLeaderStoryPhoto(file, pk=1) {
  return (dispatch) => {
    return dispatch(uploadLeaderStoryPhoto(file))
  }
}


function saveRecommendedResource(data) {
  let token = Cookie.get(AUTH_COOKIE_PATH);

  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_RECOMMENDED_RESOURCE),
      endpoint: `user/recommend/resource/`,
      method: 'post',
      headers: { 'Authorization': `Token ${token}`},
      data
    }
  };
}

export function doSaveRecommendedResource(data) {
  return (dispatch, getState) => {
    return dispatch(saveRecommendedResource(data));
  };
}

function fetchMySuggestions(params) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
        types: makeActionTriplet(actionTypes.FETCH_MY_SUGGESTIONS),
        endpoint: `user/me/suggestions/`,
        method: 'get',
        data: params,
        headers: { 'Authorization': `Token ${token}`}
    }
  };
}

export function loadMySuggestions(params) {
  return (dispatch, getState) => {
    return dispatch(fetchMySuggestions(params));
  };
}


function saveOrganizationApplication(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_ORGANIZATION_APPLICATION),
      endpoint: `organizations/new/application/`,
      method: 'post',
      data
    }
  };
}


export function doSaveOrganizationApplication(data) {
  return (dispatch, getState) => {
    return dispatch(saveOrganizationApplication(data));
  };
}

function saveBFWApplication(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.SAVE_BFW_APPLICATION),
      endpoint: `organizations/bfw/application/`,
      method: 'post',
      data
    }
  }
}

export function doSaveBFWApplication(data) {
  return (dispatch, getState) => {
    return dispatch(saveBFWApplication(data));
  };
}

function updateBFWApplication(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.UPDATE_BFW_APPLICATION),
      endpoint: `organizations/bfw/application/update/`,
      method: 'patch',
      data
    }
  };
}

export function doUpdateBFWApplication(data) {
  return (dispatch, getState) => {
    return dispatch(updateBFWApplication(data));
  };
}


function fetchCategoryLPCollection(accessKey) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_CATEGORY_BANNER_SLIDER_COLLECTION),
      endpoint: `collections/${accessKey}/`,
      method: 'get',
      data: null
    }
  };
}


export function loadCategoryLPCollection(accessKey) {
  return (dispatch, getState) => {
    return dispatch(fetchCategoryLPCollection(accessKey));
  };

}


function fetchNotifications() {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_NOTIFICATIONS),
      endpoint: 'notifications/',
      method: 'get',
      data: null,
      headers: { 'Authorization': `Token ${token}`},
      schema: null
    }
  };
}

export function loadNotifications() {
  return (dispatch, getState) => {
    return dispatch(fetchNotifications());
  };
}


function fetchNotification(id) {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_NOTIFICATION),
      endpoint: `notifications/${id}/`,
      method: 'get',
      data: null,
      headers: { 'Authorization': `Token ${token}`},
      schema: null
    }
  };
}

export function loadNotification(id) {
  return (dispatch, getState) => {
    return dispatch(fetchNotification(id));
  };
}


export function updateRegionFilter(regionId) {
  return {
    type: actionTypes.UPDATE_REGION_FILTER,
    regionId: regionId
  };
}

export function flipGlobalFilter() {
  return {
    type: actionTypes.UPDATE_REGION_FILTER,
    global: 1
  };
}

function fetchFeaturedOrganizations(categoryId) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FEATURED_ORGANIZATIONS),
      endpoint: `organizations/`,
      method: 'get',
      data: { featured: categoryId },
      schema: null
    }
  };
}


export function loadFeaturedOrganizations(categoryId) {
  return (dispatch, getState) => {
    return dispatch(fetchFeaturedOrganizations(categoryId));
  };
}

function fetchCollageOrganizations(){
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_COLLAGE_ORGANIZATIONS),
      endpoint: `organizations/is_collage/`,
      method: 'get',
      data: null,
      schema: null
    }
  };
}

export function loadCollageOrganizations() {
  return (dispatch, getState) => {
    return dispatch(fetchCollageOrganizations());
  };
}


function fetchFlatPages() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_FLATPAGES),
      endpoint: 'pages/',
      method: 'get',
      data: null,
      schema: null
    }
  };
}

export function loadFlatPages() {
  return (dispatch, getState) => {
    return dispatch(fetchFlatPages());
  };
}


function fetchKeywordSearchResults(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_KEYWORD_SEARCH_RESULTS),
      endpoint: 'organizations/',
      method: 'get',
      data,
      schema: null
    }
  };
}

export function loadKeywordSearchResults(q, limit, offset) {
  let data = {q, limit, offset};
  return (dispatch, getState) => {
    return dispatch(fetchKeywordSearchResults(data));
  };
}


export function browserGeolocationRequest(position) {
  return  {
    type: actionTypes.BROWSER_GEOLOCATION_REQUEST
  };
}

export function browserGeolocationSuccess(position) {
  return  {
    type: actionTypes.BROWSER_GEOLOCATION_SUCCESS,
    payload: position
  };
}

export function browserGeolocationFailure(error) {
  return  {
    type: actionTypes.BROWSER_GEOLOCATION_FAILURE,
    payload: error
  };
}


export function serverGeolocation() {
  let token = Cookie.get(AUTH_COOKIE_PATH);
  let headers = {};
  if (token) {
    headers = { 'Authorization': `Token ${token}`};
  }
  return {
    [CALL_API]: {
      types: makeFSATripplet(actionTypes.SERVER_GEOLOCATION),
      endpoint: 'user/geolocate/',
      method: 'get',
      headers
    }
  };
}


function fetchSearchSuggestions(data) {
  return {
    [CALL_API]: {
      types: makeFSATripplet(actionTypes.SEARCH_AUTOCOMPLETE),
      endpoint: 'organizations/autocomplete/',
      method: 'get',
      data
    }
  };
}

export function loadSearchSuggestions(snippet) {
  return (dispatch, getState) => {
    return dispatch(fetchSearchSuggestions({snippet}));
  };
}

export function uploadAvatar(file) {
  let csrftoken = Cookie.get('csrftoken');
  let token = Cookie.get(AUTH_COOKIE_PATH);
  let data = new FormData();
  data.append("display_picture", file);
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.UPLOAD_AVATAR),
      endpoint: 'user/me/',
      method: 'patch',
      data,
      headers: {
        'X-CSRFToken': `${csrftoken}`,
        'Content-Type': 'multipart/form-data',
        'Authorization': `Token ${token}`
      },
      schema: null
    }
  };
}

function fetchBFWOrganizations(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_BFW_ORGANIZATIONS),
      endpoint: 'organizations/bfw/',
      method: 'get',
      data,
      schema: null
    }
  };
}

export function loadBFWOrganizations(data) {
  return (dispatch, getState) => {
    return dispatch(fetchBFWOrganizations(data));
  };
}

function fetchOrgsByType(data) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_ORGS_BY_TYPE),
      endpoint: 'organizations/org-by-type/',
      method: 'get',
      data,
      schema: null
    }
  };
}

export function loadOrgsByType(data) {
  return (dispatch, getState) => {
    return dispatch(fetchOrgsByType(data));
  };
}


export function openLoginFormRequest(payload={next: null}) {
  console.info(payload)
  return {
    type: actionTypes.OPEN_LOGIN_FORM_REQUEST,
    payload
  }
}

export function openLoginFormSuccess() {
  return {
    type: actionTypes.OPEN_LOGIN_FORM_SUCCESS
  }
}

export function openLoginFormFailure() {
  return {
    type: actionTypes.OPEN_LOGIN_FORM_FAILURE
  }
}

export function closeLoginFormRequest() {
  return {
    type: actionTypes.CLOSE_LOGIN_FORM_REQUEST
  }
}

export function closeLoginFormSuccess() {
  return {
    type: actionTypes.CLOSE_LOGIN_FORM_SUCCESS
  }
}

export function closeLoginFormFailure() {
  return {
    type: actionTypes.CLOSE_LOGIN_FORM_FAILURE
  }
}

export function openSignupFormRequest(payload={next: null}) {
  return {
    type: actionTypes.OPEN_SIGNUP_FORM_REQUEST,
    payload
  }
}

export function openSignupFormSuccess() {
  return {
    type: actionTypes.OPEN_SIGNUP_FORM_SUCCESS
  }
}

export function openSignupFormFailure() {
  return {
    type: actionTypes.OPEN_SIGNUP_FORM_FAILURE
  }
}

export function closeSignupFormRequest() {
  return {
    type: actionTypes.CLOSE_SIGNUP_FORM_REQUEST
  }
}

export function closeSignupFormSuccess() {
  return {
    type: actionTypes.CLOSE_SIGNUP_FORM_SUCCESS
  }
}

export function closeSignupFormFailure() {
  return {
    type: actionTypes.CLOSE_SIGNUP_FORM_FAILURE
  }
}

function fetchCategoryEvents() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_CATEGORY_EVENTS),
      endpoint: 'girls-festival/category-events/'
    }
  };
}

export function loadCategoryEvents() {
  return (dispatch, getState) => {
    return dispatch(fetchCategoryEvents());
  };
}

function fetchTimesEvents() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_TIMES_EVENTS),
      endpoint: 'girls-festival/times-events/'
    }
  };
}

export function loadTimesEvents() {
  return (dispatch, getState) => {
    return dispatch(fetchTimesEvents());
  };
}

function fetchStoriesByCategoryRoot(id) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_STORIES_BY_CATEGORY_ROOT),
      endpoint: `user/stories-by-root-category/${id}/`,
    }
  };
}


export function loadStoriesByCategoryRoot(id) {
  return (dispatch, getState) => {
    return dispatch(fetchStoriesByCategoryRoot(id));
  };
}

function fetchStoriesByCategory() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_STORIES_BY_CATEGORY),
      endpoint: `user/stories-by-category/`,
    }
  };
}


export function loadStoriesByCategory() {
  return (dispatch, getState) => {
    return dispatch(fetchStoriesByCategory());
  };
}

function fetchStoriesCategoryNames() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_STORY_CATEGORY_NAMES),
      endpoint: 'user/stories-category-names/'
    }
  };
}

export function loadStoriesCategoryNames() {
  return (dispatch, getState) => {
    return dispatch(fetchStoriesCategoryNames())
  };
}

function fetchSponsors() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_SPONSORS),
      endpoint: 'girls-festival/sponsors/'
    }
  }
}

export function loadSponsors() {
  return (dispatch, getState) => {
    return dispatch(fetchSponsors())
  };
}

function fetchNewsletters() {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_HOME_PAGE_NEWSLETTERS),
      endpoint: 'organizations/newsletter/list/'
    }
  }
}

export function loadNewsletters() {
  return (dispatch, getState) => {
    return dispatch(fetchNewsletters())
  };
}

function fetchNewsletter(id) {
  return {
    [CALL_API]: {
      types: makeActionTriplet(actionTypes.FETCH_NEWSLETTER),
      endpoint: `organizations/newsletter/${id}/`
    }
  }
}

export function loadNewsletter(id) {
  return (dispatch, getState) => {
    return dispatch(fetchNewsletter(id))
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js